import Api from "@/api/pig-registration/deadline/RegistrationDeadlineApi";
export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await Api.addOrUpdate(form);
        await dispatch('NOTIFY_MSG', 'pigRegistration.notification.savePigletTransport', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async remove({dispatch}, {id}) {
      try {
        const response = await Api.remove(id);
        await dispatch('NOTIFY_MSG', 'pigRegistration.notification.savePigletTransport', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  },
}
